import { InjectionToken } from '@angular/core';

export interface NavigationConfig {
    route: string;
    icon: string;
}
export const NAVIGATION_CONFIG = new InjectionToken<NavigationConfig>('DEFAULT_NAVIGATION_CONFIG');
